import React from 'react';

function Heading() {
    return (
        <header>
            <h1>The Keeper App</h1>
        </header>
    );
}

export default Heading;